import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectContact extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      contacts: props.contacts,
      default_contacts: props.default_contacts,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
    };
  }

  componentDidMount() {
  }

  renderSelectContact() {
    let debounceTimer;
    const account = this.state.account;
    const contacts = this.state.contacts;
    const default_contacts = this.state.default_contacts;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        contacts: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/contacts/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!contacts && (!default_contacts || default_contacts.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_contacts: options });
        });
      }
    };

    const customOption = (contact) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {contact["title"]}
            </div>
            {contact["badge"] && <div className="ml-auto small">
              {contact["badge"]}
            </div>}
          </div>
          {contact["description"] && <div className="small select-description">
            {contact["description"]}
          </div>}
        </div>
      );
    };

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_contacts}
        isMulti={multiple}
        placeholder={this.props.placeholder || "Select a contact..."}
        value={contacts}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectContact()}
      </div>
    );
  }
}

SelectContact.propTypes = {
  account: PropTypes.object,
  contacts: PropTypes.object,
  default_contacts: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
};
export default SelectContact;
